import { useCallback, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { supabase } from "../supabaseClient"
import { useUser } from "../UserContext"
import { useOrganization } from "../OrganizationContext"

export default function GTMManagement() {
  const user = useUser()
  const { selectedOrgId } = useOrganization()
  const navigate = useNavigate()
  const [gtmSummary, setGtmSummary] = useState([])

  const fetchGtmSummary = useCallback(async () => {
    if (!user) return

    const { data, error } = await supabase.rpc("get_gtm_summaries", {
      uid: user.id,
      org_id: selectedOrgId,
    })

    if (error) {
      console.error("Failed to fetch GTM summary:", error)
    } else {
      setGtmSummary(data || [])
    }
  }, [selectedOrgId, user])

  useEffect(() => {
    fetchGtmSummary()
  }, [fetchGtmSummary])

  const handleViewDetails = (websiteId) => {
    if (!websiteId) {
      console.error("Missing website ID")
      return
    }
    navigate(`/website-audit/gtm-details/${websiteId}`)
  }

  return (
    <div className="page-container">
      <h2>GTM Management</h2>

      {gtmSummary.length === 0 ? (
        <p>No GTM data found.</p>
      ) : (
        <table className="ui-table" style={{ width: "100%", marginTop: "1rem" }}>
          <thead>
            <tr>
              <th>Website URL</th>
              <th># Active GTMs</th>
              <th>Last Scrape</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {gtmSummary.map((entry) => (
              <tr key={entry.website_id}>
                <td>{entry.url}</td>
                <td>{entry.active_gtm_count}</td>
                <td>{entry.last_scrape_date ? entry.last_scrape_date.split("T")[0] : "—"}</td>
                <td>
                  <button onClick={() => handleViewDetails(entry.website_id)}>
                    View Details
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}
